<template lang="pug">
li.content(v-if="showDownload")
    .icon.file(
        v-if="filetype === 'file'"
        :style="{ 'min-width': `${width}px`, height: `${height}px` }"
    )
        font-awesome-icon(icon="file-alt")

    //- a.thumbnail(
    //-     v-else-if="filetype === 'image' && thumbnail"
    //-     href="#" @click.stop.prevent="$emit('crop', media)"
    //-     :style="{ 'min-width': `${width}px`, height: `${height}px` }"
    //- )
        img(:src="thumbnail" :style="{ 'min-width': `${width}px`, height: `${height}px` }")

    .icon(
        v-else
        :class="filetype"
        :style="{ 'min-width': `${width}px`, height: `${height}px` }"
    )
        font-awesome-icon(:icon="`file-${filetype}`")

    .filename(v-line-clamp:24="1") {{ filename }}
    .filesize {{ filesize }}
    .actions
        a(:href="`${src}?download`") herunterladen
</template>

<script>
import { get, trim } from '@/helpers';
import prettyBytes from 'pretty-bytes';
import mime from 'mime';

export default {
    name: 'MediaPreview',
    props: {
        media: {
            type: Object,
            required: true
        },
        width: {
            type: Number,
            required: true
        },
        height: {
            type: Number,
            required: true
        },
        showDownload: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        type() {
            return this.media.type;
        },
        file() {
            switch (this.type) {
                case 'file':
                    return get(this.media, 'file');
                case 'image':
                case 'video':
                    return get(this.media, `${this.type}.source`);
                default:
                    return undefined;
            }
        },
        filename() {
            return get(this.file, 'name');
        },
        filesize() {
            let size;
            size = get(this.file, 'size');
            size = prettyBytes(parseInt(size));
            return size;
        },
        filetype() {
            let filetype;

            const m = get(this.file, 'mime');
            const suffix = mime.getExtension(m);
            switch (suffix) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                    filetype = 'image';
                    break;

                case 'mp4':
                case 'mpeg':
                case 'webm':
                case 'qt':
                    filetype = 'video';
                    break;

                case 'zip':
                case 'rar':
                case 'gzip':
                case 'tar':
                case 'tar.gz':
                case 'tar.gzip':
                    filetype = 'archive';
                    break;

                case 'doc':
                case 'docx':
                case 'docm':
                case 'docb':
                case 'dotx':
                case 'dotm':
                    filetype = 'word';
                    break;

                case 'ppt':
                case 'pptx':
                case 'pptm':
                    filetype = 'powerpoint';
                    break;

                case 'xls':
                case 'xlsx':
                    filetype = 'excel';
                    break;

                case 'csv':
                    filetype = 'csv';
                    break;

                case 'mp3':
                case 'wav':
                    filetype = 'audio';
                    break;

                default:
                    filetype = 'file';
            }

            return filetype;
        },
        src() {
            let storageRoute = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`;
            storageRoute = trim(storageRoute, '/');

            let table = 'files';

            let id = this.file.id;
            const name = this.file.name;

            switch (this.type) {
                case 'image':
                    table = 'images';
                    id = get(this.media, `${this.type}.id`);
                    break;

                case 'video':
                    table = 'videos';
                    id = get(this.media, `${this.type}.id`);
                    break;
            }

            return `${storageRoute}/${table}/${id}/${name}`;
        },
        thumbnail() {
            if (this.type === 'image') {
                const fit = `fit=crop&crop=focalpoint&x=.5&y=.5&z=1&w=${this.width}&h=${this.height}`;
                // const fit = `fit&h=${this.height}`
                return `${this.src}&${fit}`;
            }

            return undefined;
        }
    }
};
</script>

<style lang="sass" scoped>

@import '~@/assets/sass/variables'

li.content
    background: rgba($color-preload-bg, 50%)
    @apply grid mb-2 pr-2
    grid-template-rows: 30px 18px 22px
    grid-template-columns: max-content auto

    &.deleted
        .thumbnail, .filename, .filesize, .actions, .icon
            opacity: .6
            filter: grayscale(1) blur(1px)
            user-select: none
            pointer-events: none

    .thumbnail
        @apply relative
        img
            background: #1a1a1d
            border-top-left-radius: 4px
            border-bottom-left-radius: 4px
            display: block

    .icon
        font-size: 2.5rem
        display: flex
        justify-content: center
        align-items: center
        color: $color-primary

    .filename, .filesize, .actions
        line-height: 1.3
        grid-column: 2

    .filename
        padding-right: 30px
        font-size: 1rem
        line-height: 24px
        padding-top: 2px

    .filesize
        font-size: .8rem

    .actions
        a
            @apply font-semibold text-black
            font-size: 1rem
            text-decoration: none
            &:hover
                text-decoration: underline
</style>
